module.exports = __webpack_public_path__ + "img/新月未到.0201dd0b.svg";